<template>
  <i> <span v-if="presence" :class="{ 'active': online['.value'] }" style="display:inline"></span> {{ user.firstname }}<i v-if="showDeli">{{ deli }}</i> </i>
</template>

<script>
import { db } from '@/firebase'

export default {
  name: 'FirstName',
  props: ['member', 'deli', 'showDeli', 'presence'],
  firebase () {
    return {
      user: {
        source: db.ref('users/' + this.member),
        asObject: true
      },
      online: {
        source: db.ref('presence/' + this.member),
        asObject: true
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// FirstNameList.vue?76199d0e